export default "__VITE_ASSET__CM2VEp9P__"